
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6036bd28&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PasswordRemindComplete.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PasswordRemindComplete.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-6036bd28!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PasswordRemindComplete.vue"),
  /* scopeId */
  "data-v-6036bd28",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/PasswordRemindComplete.vue
// module id = 610
// module chunks = 0